import React from "react";

interface AccordionExpandIconProps {
    width?: number;
    height?: number;
    fillColor?: string;
    strokeColor?: string;
}

const AccordionExpandIcon = ({
    width = 24,
    height = 24,
    fillColor = "#3674EE",
    strokeColor = "white",
}: AccordionExpandIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="12" r="12" fill={fillColor} />
            <path
                d="M7.33398 12H16.6673"
                stroke={strokeColor}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default AccordionExpandIcon;
